import { translate } from "@/i18n";
import { libChatMessages } from "@/i18n/messages/lib-chat";

export interface DirectSuggestion {
  kind: "send" | "open_app" | "mark_done";
  label: string;
  message?: string;
  url?: string;
}

export interface DirectResult {
  taskId: string | null;
  /** The task's project; the chat showing the card may belong to another. */
  projectId: string | null;
  title: string;
  suggestions: DirectSuggestion[];
}

function isSuggestion(value: unknown): value is DirectSuggestion {
  if (typeof value !== "object" || value === null) return false;
  const candidate = value as Record<string, unknown>;
  if (
    candidate.kind !== "send" &&
    candidate.kind !== "open_app" &&
    candidate.kind !== "mark_done"
  )
    return false;
  if (typeof candidate.label !== "string" || !candidate.label) return false;
  if (
    candidate.kind === "send" &&
    (typeof candidate.message !== "string" || !candidate.message)
  )
    return false;
  if (
    candidate.kind === "open_app" &&
    (typeof candidate.url !== "string" || !candidate.url)
  )
    return false;
  return true;
}

/** Identity of a direct-session result notice, or undefined for other messages. */
export function directResultNotice(
  metadata: Record<string, unknown> | undefined,
  content: string,
): DirectResult | undefined {
  if (metadata?.direct_result !== true) return undefined;
  const taskId =
    typeof metadata.task_id === "string" && metadata.task_id
      ? metadata.task_id
      : null;
  const projectId =
    typeof metadata.project_id === "string" && metadata.project_id
      ? metadata.project_id
      : null;
  const suggestions = Array.isArray(metadata.suggestions)
    ? metadata.suggestions.filter(isSuggestion).slice(0, 3)
    : [];
  const title =
    content.split("\n")[0]?.trim() ||
    translate(libChatMessages, "directSessionUpdate");
  return { taskId, projectId, title, suggestions };
}
